var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10SmartBottlePoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.54077C21.2264 6.54077 25.4592 10.7735 25.4592 16C25.4592 21.2264 21.2264 25.4592 16 25.4592C10.7735 25.4592 6.54077 21.2264 6.54077 16C6.54077 10.7735 10.7735 6.54077 16 6.54077Z",
    fill: "#396EF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.95972C23.2009 2.95972 29.0403 8.79913 29.0403 16C29.0403 23.2009 23.2009 29.0403 16 29.0403C8.79913 29.0403 2.95972 23.2009 2.95972 16C2.95972 8.79913 8.79913 2.95972 16 2.95972ZM16 4.6696C22.2588 4.6696 27.3304 9.74118 27.3304 16C27.3304 22.2588 22.2588 27.3304 16 27.3304C9.74118 27.3304 4.6696 22.2588 4.6696 16C4.6696 9.74118 9.74118 4.6696 16 4.6696Z",
    fill: "#396EF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10SmartBottlePoints);
export default __webpack_public_path__ + "static/media/10_smart_bottle_points.59a8f1f5c224056ea1305c484f216e69.svg";
export { ForwardRef as ReactComponent };